import React, { Children } from 'react';
import { motion } from 'framer-motion';
const teamMembers = [{
  name: 'Javier Garcilazo',
  role: 'FUNDADOR DE LA RESIDENCIA',
  initials: 'JG',
  image: 'https://cdn.magicpatterns.com/uploads/j3K8UJewouprzGnVaLiU5P/mejorame_la_foto_2K_202605110138.jpg'
}, {
  name: 'Lic. Juliana Zapata',
  role: 'NUTRICIÓN',
  initials: 'JZ',
  image: 'https://cdn.magicpatterns.com/uploads/bPZBjY3kxfAr8hSh4Z1Tyw/Lic._En_nutricion_Juliana_Zapata.jpg'
}, {
  name: 'Germán Hirigoyen',
  role: 'BIOINGENIERÍA MG',
  initials: 'GH',
  image: 'https://cdn.magicpatterns.com/uploads/3VvumHqktVzGtJ18DH9apS/Bioingenieria_MG_German_Hirigoyen.jpg'
}, {
  name: 'Angela Belz',
  role: 'PSICOLOGÍA',
  initials: 'AB',
  image: 'https://cdn.magicpatterns.com/uploads/amoV8sao5JPGHQc8Xz8qJe/Psicologa_Angela_Belz.jpg'
}, {
  name: 'Dr. Cari Reh',
  role: 'DIRECCIÓN MÉDICA',
  initials: 'CR',
  image: 'https://cdn.magicpatterns.com/uploads/uDMwm9Xihm7GMdNcoVQM8k/Coordinadora_Dr_Cari_Reh.jpg'
}, {
  name: 'Joaquín Sánchez',
  role: 'EDUCACIÓN FÍSICA',
  initials: 'JS',
  image: 'https://cdn.magicpatterns.com/uploads/vpAZNXqQPnZyJ7ipC47Yer/Joaquin_Sanchez_Porfe_Edicacion_Fisica.jpg'
}, {
  name: 'María Alaniz',
  role: 'CUIDADOS GERONTOLÓGICOS',
  initials: 'MA',
  image: 'https://cdn.magicpatterns.com/uploads/rmhcFc3s9taXChotn1qhKJ/Maria_Alaniz_Cuidadora_de_adultos_mayores.jpg'
}, {
  name: 'Lic. Cristian Godoy',
  role: 'ENFERMERÍA',
  initials: 'CG',
  image: 'https://cdn.magicpatterns.com/uploads/mLttwQ9iAxmhZg7jXMAhAY/mejorame_la_foto_2K_202605110139.jpg'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function TeamSection() {
  return <section className="py-20 px-5 md:px-[5%] bg-white text-center" data-id="element-86">
      <div className="max-w-7xl mx-auto" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-[800px] mx-auto mb-10" data-id="element-88">
          <h2 className="text-verde-oscuro text-3xl md:text-[2.8rem] font-serif mb-5" data-id="element-89">
            Conoce a nuestro equipo
          </h2>
          <p className="text-lg font-sans text-texto" data-id="element-90">
            La excelencia de nuestra residencia reside en la calidez humana de
            quienes cuidan a tu familia cada día.
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 mt-10" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-91">
          {teamMembers.map((member, index) => <motion.div key={index} variants={itemVariants} className="relative overflow-hidden rounded-[10px] group" data-id="element-92">
              <div className="relative h-[300px] overflow-hidden" data-id="element-93">
                {member.image ? <img src={member.image} alt={member.name} className="w-full h-full object-cover grayscale-[20%] transition-all duration-500 group-hover:scale-110 group-hover:grayscale-0" data-id="element-94" /> : <div className="w-full h-full bg-verde-vida flex items-center justify-center" data-id="element-95">
                    <span className="text-white font-sans font-bold text-6xl" data-id="element-96">
                      {member.initials}
                    </span>
                  </div>}
              </div>
              <div className="bg-white p-4" data-id="element-97">
                <h5 className="text-verde-oscuro text-[1.1rem] font-serif mb-1" data-id="element-98">
                  {member.name}
                </h5>
                <span className="text-dorado text-[0.85rem] font-bold font-sans" data-id="element-99">
                  {member.role}
                </span>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}